"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconBioOilForHeatProduction = function IconBioOilForHeatProduction(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M30 5H18a3 3 0 1 0 0 6v10h2V11h8v3h2v-3a3 3 0 1 0 0-6M18 7h12a1 1 0 1 1 0 2H18a1 1 0 1 1 0-2m22.076 31.5L34.2 28.619l-1.72 1.022 5.87 9.87.057.115A1 1 0 0 1 37.484 41H10.66l-.116-.008a1 1 0 0 1-.738-1.492l3.415-5.77-1.722-1.02-3.42 5.78-.1.19A3.002 3.002 0 0 0 10.654 43H37.49l.2-.008a3 3 0 0 0 2.386-4.492m-5.563-22.397 1.414 1.414L20.452 33H23v2h-4.547l-3.396 3.397-1.414-1.414L23 27.621V23h2v2.62zM30.29 29.63a3 3 0 0 0-2.44-1.16 3 3 0 0 0-2.44 1.16 3.14 3.14 0 0 0 4.88 0m-1.73-10.55a3 3 0 0 1-1.16 2.44 3.14 3.14 0 0 1 0-4.88 3 3 0 0 1 1.16 2.44m7.22 5.27a3 3 0 0 0-2.44-1.16 3 3 0 0 0-2.44 1.16 3.14 3.14 0 0 0 4.88 0M19.6 28.19a3 3 0 0 1-1.16 2.44 3.14 3.14 0 0 1 0-4.88 3 3 0 0 1 1.16 2.44m21.06-8.71a3 3 0 0 0-2.44-1.16 3 3 0 0 0-2.44 1.16 3.14 3.14 0 0 0 4.88 0",
    clipRule: "evenodd"
  })));
};

export { IconBioOilForHeatProduction, IconBioOilForHeatProduction as default };
